import { AxiosError, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'
import toast from 'react-hot-toast'
import { Referral } from '@playback-rewards/shared-libraries'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getReferrer } from 'services/referalService'

const useQueryGetReferrer = () => {
  const { data, isLoading } = useQuery<AxiosResponse<Referral, Error>>(
    QueryKeys.GET_REFERRER,
    getReferrer,
    {
      onError: (error) => {
        toast.error(
          ((error as AxiosError)?.response?.data as Error).message || 'Something went wrong!'
        )
      },
    }
  )

  return {
    isLoadingReferrer: isLoading,
    referrer: data?.data,
  }
}

export default useQueryGetReferrer
